export const numberRegex = /^\d+$/;
export const usaPhoneRegex = /^(\+?1\s?)?(\(?\d{0,3}\)?[\s.-]?)?\d{0,3}[\s.-]?\d{0,4}$/;
export const positiveNumbersOneZeroRegex = /^(0|[1-9]\d*)?$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const wholeNumbersRegex = /^(0|[1-9][0-9]*)?$/;
export const decimalNumbersRegex = /^$|^(0|[1-9]\d*)(\.\d{0,2})?$/;
export const decimalMinusNumbersRegex = /^$|^-$|^-?(0|[1-9]\d*)(\.\d{0,2})?$/;